module.exports = __webpack_public_path__ + "img/soil_moisture.c1654e16.svg";